import { CheckboxShape as FluentCheckboxShape, CheckboxSize as FluentCheckboxSize } from "@fluentui/web-components";
export const CheckboxShapes = {
    ...FluentCheckboxShape
};
export const CheckboxSizes = {
    ...FluentCheckboxSize
};
//# sourceMappingURL=checkbox.options.js.map